import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 操作记录
interface RecordJson {
    type: string,
    relation_id: string,
}

export const record = (json: RecordJson): any => http.httpPost({
    url: httpApi.operation.record,
    json
})

// 用户行为记录
interface FootprintJson {
    module_index: string,
    deed: string,
    relation_id: string,
}

export const footprint = (json: FootprintJson): any => http.httpPost({
    url: httpApi.operation.footprint,
    json
})

// 新前台日志管理
export const getUpdateLog = (json: any): any => http.httpPost({
    url: httpApi.operation.getUpdateLog,
    json
})

// 获取新闻列表
export const getNewsList = (json: any) =>
  http.httpGet({
    url: httpApi.operation.getNewsList,
    json
  });

// 获取新闻详情
export const getNewsDetail = (json: any) =>
  http.httpGet({
    url: httpApi.operation.getNewsDetail,
    json
  });
